import {
    GetIntegracoesWhatsappService,
    InserirArquivoDriveService,
} from "../../../Services/Geral/Integracoes/IntegracoesServices";
import { Controller } from "../../Controller";

export async function GetIntegracoesWhatsappController() {
    return Controller(GetIntegracoesWhatsappService());
}

export async function InserirArquivoDriveController(
    idCaso: number,
    file: File
) {
    return Controller(InserirArquivoDriveService(idCaso, file));
}
